export const FeatureName = 'subsidiaries';
